'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = intlMethods;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _reactIntl = require('react-intl');

var _reactIntl2 = _interopRequireDefault(_reactIntl);

var methods = ['formatDate', 'formatNumber', 'formatRelative', 'formatTime', 'getMessageFormat',
// "private methods":
'_format', 'getDateTimeFormat', 'getMessageFormat', 'getNamedFormat', 'getNumberFormat', 'getRelativeFormat'];

exports.methods = methods;

function intlMethods() {
  var keyMap = arguments[0] === undefined ? function (v) {
    return v;
  } : arguments[0];
  var keyExists = arguments[1] === undefined ? function () {
    return false;
  } : arguments[1];

  return function (Component) {

    var maybeWarnForOverride = function maybeWarnForOverride(method) {
      if (process.env.NODE_ENV !== 'production') {
        if (Component.prototype[method] && !Component.prototype[method].__mine) {
          console.warn('Overriding instance method \'' + method + '\' for Component \'' + Component.name + '\'');
        }
      }
    };

    Component.contextTypes = _extends({}, Component.contextTypes || {}, _reactIntl.contextTypes);

    // all normal intl methods

    methods.forEach(function (method) {
      if (!Component.prototype[method] || !Component.prototype[method].__mine) {
        maybeWarnForOverride(method);

        Component.prototype[method] = function () {
          var _ri$method;

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return (_ri$method = _reactIntl2['default'][method]).call.apply(_ri$method, [this].concat(args));
        };
        Component.prototype[method].__mine = true;
      }
    });

    // normal `formatMessage`, key transformed by `keyMap`

    if (!Component.prototype.formatMessage || !Component.prototype.formatMessage.__mine) {
      maybeWarnForOverride('formatMessage');

      Component.prototype.formatMessage = function (key) {
        for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }

        return _reactIntl2['default'].formatMessage.apply(this, [_reactIntl2['default'].getIntlMessage.call(this, keyMap.call(this, key))].concat(args));
      };
      Component.prototype.formatMessage.__mine = true;
    }

    // optional `formatMessageIfItExists`,
    // formats only if `keyExists(keyMap(k)) is true`

    if (!Component.prototype.formatMessageIfItExists || !Component.prototype.formatMessageIfItExists.__mine) {
      maybeWarnForOverride('formatMessageIfItExists');

      Component.prototype.formatMessageIfItExists = function (key) {
        for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
          args[_key3 - 1] = arguments[_key3];
        }

        return keyExists.call(this, keyMap.call(this, key)) ? this.formatMessage.apply(this, [key].concat(args)) : key;
      };
      Component.prototype.formatMessageIfItExists.__mine = true;
    }

    return Component;
  };
}

// optional keyMap fn
// When provided, it should map translation keys for Messages to custom translation keys
// it is executed with Component instance as context
// (you can access `this.props`, `this.context` or whatever)

// used by `formatMessageIfItExists`
// should return true if message key exists
// it is executed with Component instance as context
// (you can access `this.props`, `this.context` or whatever)
// key in input is already `keyMap`ped


// WEBPACK FOOTER //
// ./~/react-intl-hoc/lib/intlMethods.js